
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M15.063 6.355c.091.518.134 1.048.134 1.575 0 1.116-.189 2.15-.543 3.072-.651.003-2.129.018-3.56.079a3.578 3.578 0 00.844-1.741H7.751V6.355z","fill":"#4285F4"}}),_c('path',{attrs:{"d":"M3.402 9.237c.505 1.506 1.75 2.695 3.299 3.073a2.332 2.332 0 00-.33.724c-.154.603-.244 1.473-.297 2.286a7.751 7.751 0 01-5.25-4.086V9.237z","fill":"#34A853"}}),_c('path',{attrs:{"d":"M3.4 9.237a4.643 4.643 0 010-2.967V4.273H.824a7.758 7.758 0 000 6.961l2.574-1.997z","fill":"#FBBC04"}}),_c('path',{attrs:{"d":"M7.751 3.068a4.212 4.212 0 012.974 1.162l2.213-2.213A7.45 7.45 0 007.751.001 7.75 7.75 0 00.825 4.273L3.399 6.27c.613-1.838 2.33-3.202 4.352-3.202z","fill":"#EA4335"}}),_c('path',{attrs:{"d":"M15.782 12.001c1.119.006 5.224.05 6.37.366a2.139 2.139 0 011.498 1.51c.299 1.102.343 3.185.35 3.894v.333c-.004.49-.038 2.835-.35 4.032a2.139 2.139 0 01-1.499 1.511c-1.182.314-5.518.349-6.467.353h-.368c-.947-.005-5.273-.04-6.468-.367a2.139 2.139 0 01-1.499-1.51c-.288-1.09-.339-3.171-.348-3.88l-.002-.202V17.99v-.031l.002-.201c.01-.705.06-2.779.348-3.88a2.183 2.183 0 011.499-1.525c.554-.147 1.801-.233 3.068-.283l.506-.018c1.175-.038 2.29-.048 2.794-.051zm-1.977 3.43v5.138L18.23 18l-4.425-2.57z","fill":"red"}})])])
          )
        }
      }
    